// components/layout/NavigationSettings.jsx
import React from 'react';
import GameDiscoverySettings from '../discovery/GameDiscoverySettings';
import GenreAnalyticsSettings from '../genre/GenreAnalyticsSettings';
import TrendingAnalyticsSettings from '../trending/TrendingAnalyticsSettings';
import RegionalAnalyticsSettings from '../regional/RegionalAnalyticsSettings';

const NavigationSettings = ({ activeSection }) => {
    switch (activeSection) {
        case 'discovery':
            return <GameDiscoverySettings />;
        case 'genre':
            return <GenreAnalyticsSettings />;
        case 'trending':
            return <TrendingAnalyticsSettings />;
        case 'regional':
            return <RegionalAnalyticsSettings />;
        default:
            return null;
    }
};

export default NavigationSettings;